/* LUMINA portfolio page v5: hero intro, parallax, video scale, lifestyle reveal, feature slider, before/after, more builds. Content never depends on this file. */
(function () {
  if (window.__cs4) return;
  window.__cs4 = true;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var design = !!(window.Shopify && window.Shopify.designMode);
  var still = reduce || design;
  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  var ease = function (p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; };

  /* Hero intro */
  function hero(h) {
    if (h.__cs4) return; h.__cs4 = true;
    window.setTimeout(function () { h.classList.add('is-in'); }, 60);
  }

  /* Feature slider */
  function features(sec) {
    if (sec.__cs4) return; sec.__cs4 = true;
    var track = sec.querySelector('.cs4-ft__track'), bar = sec.querySelector('.cs4-ft__bar span');
    if (!track) return;
    function step() { var c = track.querySelector('.cs4-ft__card'); return c ? c.offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 24) : 300; }
    function paint() { var m = track.scrollWidth - track.clientWidth; var p = m > 0 ? track.scrollLeft / m : 0; if (bar) bar.style.setProperty('--w', Math.max(6, p * 100).toFixed(2) + '%'); }
    function go(d) {
      var s = step(), max = track.scrollWidth - track.clientWidth;
      var to = clamp(Math.round((track.scrollLeft + d * s) / s) * s, 0, max);
      if (still) { track.scrollLeft = to; return; }
      var from = track.scrollLeft, t0 = performance.now(), D = 520;
      track.style.scrollSnapType = 'none';
      (function tick(t) { var k = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - k, 3); track.scrollLeft = from + (to - from) * e; if (k < 1) requestAnimationFrame(tick); else track.style.scrollSnapType = 'x mandatory'; })(t0);
    }
    track.addEventListener('scroll', paint, { passive: true });
    $all(sec, '[data-prev]').forEach(function (b) { b.addEventListener('click', function () { go(-1); }); });
    $all(sec, '[data-next]').forEach(function (b) { b.addEventListener('click', function () { go(1); }); });
    paint();
  }

  /* Before and after */
  function compare(box) {
    if (box.__cs4) return; box.__cs4 = true;
    var drag = false;
    function set(e) { var r = box.getBoundingClientRect(); var x = (e.touches ? e.touches[0].clientX : e.clientX); box.style.setProperty('--ba', (clamp((x - r.left) / r.width, 0.03, 0.97) * 100).toFixed(2) + '%'); }
    box.addEventListener('pointerdown', function (e) { drag = true; set(e); });
    box.addEventListener('pointermove', function (e) { if (drag) set(e); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (n) { box.addEventListener(n, function () { drag = false; }); });
    box.addEventListener('keydown', function (e) { var v = parseFloat(box.style.getPropertyValue('--ba')) || 50; if (e.key === 'ArrowLeft') { box.style.setProperty('--ba', clamp(v - 4, 3, 97) + '%'); e.preventDefault(); } if (e.key === 'ArrowRight') { box.style.setProperty('--ba', clamp(v + 4, 3, 97) + '%'); e.preventDefault(); } });
  }

  /* More builds: one card open at a time, rotates while nobody hovers */
  function more(row) {
    if (row.__cs4) return; row.__cs4 = true;
    var items = $all(row, 'li'), i = 0, hover = false, el = 0, last = 0;
    if (!items.length) return;
    function act(n) { i = (n + items.length) % items.length; items.forEach(function (li, k) { li.classList.toggle('is-act', k === i); }); el = 0; }
    items.forEach(function (li, k) {
      li.addEventListener('mouseenter', function () { hover = true; act(k); });
      li.addEventListener('focusin', function () { hover = true; act(k); });
      li.addEventListener('touchstart', function (e) { if (k !== i) { act(k); } }, { passive: true });
      li.addEventListener('click', function (e) { if (k !== i) { e.preventDefault(); act(k); } });
    });
    row.addEventListener('mouseleave', function () { hover = false; });
    row.addEventListener('focusout', function () { hover = false; });
    act(0);
    if (still) return;
    (function loop(t) { var d = last ? Math.min(100, t - last) : 0; last = t; if (!hover && !document.hidden) { el += d; if (el >= 3200) act(i + 1); } requestAnimationFrame(loop); })(0);
  }

  /* Scroll driven bits */
  var pars = [], fls = [], vids = [];
  function frame() {
    var vh = window.innerHeight || 1, y = window.pageYOffset || 0;
    if (!still) {
      pars.forEach(function (el) {
        var b = el.getBoundingClientRect(); if (b.bottom < -300 || b.top > vh + 300) return;
        var k = parseFloat(el.getAttribute('data-par')) || 0, d = b.top + b.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (d * k).toFixed(1) + 'px,0)';
      });
      vids.forEach(function (v) { v.style.setProperty('--vs', (0.9 + Math.min(1, y / 500) * 0.1).toFixed(4)); });
    }
    fls.forEach(function (fl) {
      var rb = fl.getBoundingClientRect();
      var p = still ? 1 : clamp((vh * 0.85 - rb.top) / (vh * 0.9), 0, 1), e = ease(p);
      var box = fl.querySelector('.cs4-fl__box'); if (!box) return;
      box.style.setProperty('--w', (22 + e * 78).toFixed(2) + '%');
      var iw = box.offsetWidth, half = fl.clientWidth / 2 - 24;
      $all(fl, '.cs4-fl h2 span, .cs4-fl__w1, .cs4-fl__w2').forEach(function (w) {
        var d = w.classList.contains('cs4-fl__w1') ? -1 : 1, ww = w.offsetWidth, lim = Math.max(12, half - ww - 12);
        w.style.transform = 'translate(' + (d * (12 + Math.min(iw / 2 + 12, lim) * (1 - e))).toFixed(1) + 'px,-50%)';
      });
      var pics = $all(box, '.cs4-fl__pic'), pos = e * 2;
      pics.forEach(function (pc, k) { var op = pics.length === 1 ? 1 : Math.max(0, 1 - Math.abs(pos - k) * 1.6); pc.style.opacity = op.toFixed(3); pc.style.transform = 'scale(' + (1.15 - e * 0.15).toFixed(4) + ')'; });
    });
    requestAnimationFrame(frame);
  }

  function init(scope) {
    var roots = $all(scope || document, '.cs4');
    roots.forEach(function (root) {
      if (root.__cs4) return; root.__cs4 = true;
      if (!still) root.classList.add('cs2-js');
      $all(root, '.cs4-hero').forEach(hero);
      $all(root, '.cs4-ft').forEach(features);
      $all(root, '.cs4-ba').forEach(compare);
      $all(root, '.cs4-mb__row').forEach(more);
      $all(root, '[data-par]').forEach(function (el) { pars.push(el); });
      $all(root, '.cs4-fl').forEach(function (el) { fls.push(el); });
      $all(root, '.cs4-video__frame').forEach(function (el) { vids.push(el); });
      $all(root, 'video[autoplay]').forEach(function (v) { v.muted = true; v.defaultMuted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
  requestAnimationFrame(frame);
})();
